import { render, staticRenderFns } from "./THGCarYearSelect.vue?vue&type=template&id=3776bf82"
import script from "./THGCarYearSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./THGCarYearSelect.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports